import React, { Component } from 'react';
import * as rmd from 'material-ui';
import config from 'cfg';
import Promise from 'bluebird';

const POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];

class TeamPlayerPicker extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            playerId: +props.playerId,
            players: []
        };
    }

    componentWillMount() {
        this.handleEventChange(null, this.props.teamId);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.teamId !== newProps.teamId) {
            this.handleEventChange(null, newProps.teamId);
        }
    }

    handleEventChange = (key, teamId) => {
        return Promise.props({
            homeId: teamId,
            players: fetch(`${config.apis.ss2}/teams/${teamId}/members`)
                .then(response => response.status === 200 && response.json())
                .then(res => res.players)
        }).then(result => this.setState(result));
    };

    renderOption(pl) {
        const text = `${pl.number || ''}. ${pl.name}`;

        return <rmd.MenuItem key={pl.id} value={pl.id} primaryText={text} />;
    }

    render() {
        const { players, playerId, homeId } = this.state;

        const playersOptions = _.orderBy(players, [pl => POSITIONS_ORDER.indexOf(pl.position), 'number']);

        return (
            <div>
                <rmd.SelectField
                    floatingLabelText="Players"
                    value={playerId}
                    disabled={!homeId}
                    maxHeight={400}
                    onChange={(e, key, val) =>
                        this.setState({ playerId: val }, () => {
                            this.props.onChange('playerId', val);
                        })
                    }
                >
                    {playersOptions.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default TeamPlayerPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TeamPlayerPicker.js
 **/